export type CreationSubmitSource = 'direct' | 'model-page-auto'

export const shouldNavigateToCreationAfterSubmit = (
    source: CreationSubmitSource,
    isSmallScreen: boolean,
    isCreated: boolean
) => isCreated && isSmallScreen && source === 'direct'
